import React from 'react'
import { COLUMN_DATATYPE_NAMES, matchColumnType } from '../common/Utilities';

class MatchedColumnRow extends React.Component {

    getCellContent = (item, index) => {
        const csvRow = this.props.csvRow;
        const selectedKey = this.props.selectedKey;
        const csvColumnMatch = this.props.upload.csvColumnMatch[selectedKey];
        if (matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.single) {
            if (typeof(csvColumnMatch[index]) !== "undefined") {
                return csvRow[csvColumnMatch[index]];
            }
        } else if (matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.onoff) {
            if (typeof(csvColumnMatch[index]) !== "undefined") {
                return <table className="matcher"><tbody>
                    <tr><td style={{ 'width': '15%' }}>Off:</td><td>{csvRow[csvColumnMatch[index]["off"]]}</td></tr>
                    <tr><td style={{ 'width': '15%' }}>On:</td><td>{csvRow[csvColumnMatch[index]["on"]]}</td></tr>
                        </tbody></table>
            }
        } else if (matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.geo) {
            if (typeof(csvColumnMatch[index]) !== "undefined") {
                return <table className="matcher"><tbody>
                    <tr><td style={{ 'width': '25%' }}>latitude:</td><td>{csvRow[csvColumnMatch[index]["latitude"]]}</td></tr>
                    <tr><td style={{ 'width': '25%' }}>longitude:</td><td>{csvRow[csvColumnMatch[index]["longitude"]]}</td></tr>
                        </tbody></table>
            }
        }
        return "";
    }

    render() {
        let {upload,selectedKey} = this.props;
        const thisInstance = this;
        return (
            upload.templateColumns[selectedKey].map(function(col, index) {
                return <td key={index}>{thisInstance.getCellContent(col, index)}</td>
            })
        )
    }
}

export default MatchedColumnRow